import { render, staticRenderFns } from "./ModalUserWallpaperHistory.vue?vue&type=template&id=a4cefb4e&scoped=true&"
import script from "./ModalUserWallpaperHistory.vue?vue&type=script&lang=js&"
export * from "./ModalUserWallpaperHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cefb4e",
  null
  
)

export default component.exports